/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import Body from '../../static/Body';
import Card from '../../static/Card';
import { motion } from 'framer-motion';
import ImageUploader from '../../elements/ImageUploader';
import InputField from '../../elements/InputField';
import CardRow from '../../static/CardRow';
import Text from '../../elements/TextComponent';
import DocumentUploader from '../../elements/DocumentUploader';
import ExperienceInput, { Experience } from '../../elements/ExperienceInput';
import HighlightsComponent from '../../static/HighlightsComponent';
import { CreateAssistantPayload, CreateSiteAssistantPayload } from '../../../api/types';
import { createResumeAssistant, createSiteAssistant } from '../../../api/assistantsApi';
import QuestionChipsInput from '../../static/QuestionChipInput';
import Button from '../../elements/Button';
import LoaderOverlay from '../../static/LoaderOverlay';
import { useProduct } from '../../../context/ProductContext';
import EditableTextArea from '../../static/Site/EditableTextArea';
import SiteBotConfigForm, { SiteBotConfig } from '../../static/Site/SiteBotConfigForm';

// The shape HighlightsComponent wants for each experience block
type HLExperience = {
  company: string;
  years: string;
  sentences: string[];
};

interface Props {
  goToAssistants: () => void;
}

const CreateSiteAssistant: React.FC<Props> = ({goToAssistants}) => {
  
  const handleViewAssistants = () => {
      goToAssistants(); // Bubble up to Dashboard
  };

  const initialConfig: SiteBotConfig = {
    name: "Acme Site Assistant",
    company: "Acme Analytics",
    role: "Customer Success",
    companyDescription: "",
    contactEmail: "",
    contactPhone: "",
    contactUrl: "",
    supportHours: "",
    policies: "",
    regions: "",
    products: "",
    audience: "",
    compliance: "",
    customers: "",
    extraDescription: "",
    personality: {
      voice: "we (professional-neutral)",
      formality: "neutral",
      jargon: "low; define terms if used",
      sales: "suggest plan only when fit is clear",
    },
    languages: []
  };

  const [config, setConfig] = useState<SiteBotConfig>(initialConfig);

  const merge = (patch: Partial<SiteBotConfig>) => {
    setConfig((prev) => ({ ...prev, ...patch }));
    console.log(config)
  }

  const handleSubmit = async (cfg: SiteBotConfig) => {
    console.log(config)
    // Example: send to your /chat or a config endpoint
    // (botId/message shown for context; adjust as needed)
    const res = await fetch("/api/chat", {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: "Bearer <token>" },
      body: JSON.stringify({
        botId: "abc123",
        message: "Configure bot",
        ...cfg,
      }),
    });
    const data = await res.json();
    console.log("Saved:", data);
  };


  const [selectedFilesFromDocumentUploader, setSelectedFilesFromDocumentUploader] = useState<File[]>([]);



  

  const [profileImage, setProfileImage] = useState('')

  const [focus, setFocus] = useState('')
  const [focusError, setFocusError] = useState(false);

  const [questions, setQuestions] = useState<string[]>([
  ]);

  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const [loading, setLoading] = useState(false);

  const parseLanguages = (input: string) => {
    return input
      .split(/[,\s]+/)        // split on commas OR any whitespace (one or more)
      .map(s => s.trim())
      .filter(Boolean);       // remove empty strings
  }

  const isBlank = (s?: string) => !s || !String(s).trim();

  // reuse your existing description validator if you have it:
  const validateDescriptionQuick = (desc: string) => {
    const tooLong = (desc || "").length > 400;
    const sentenceCount = (desc || "")
      .split(/[.!?]+(?=\s|$)/g)
      .map((x) => x.trim())
      .filter(Boolean).length;
    const banned = /[$€£₪]|\b(?:USD|NIS|EUR|ILS)\b/i.test(desc) ||
                  /\b(?:[01]?\d|2[0-3]):[0-5]\d\b/.test(desc) ||
                  /\b(?:[01]?\d)\s?(?:am|pm)\b/i.test(desc);
    if (isBlank(desc)) return "Company description is required.";
    if (tooLong) return "Company description must be ≤ 400 characters.";
    if (sentenceCount < 1 || sentenceCount > 3) return "Company description must be 1–3 sentences.";
    if (banned) return "Company description cannot include prices or exact hours.";
    return "";
  };


  const handleFinish = async () => {
    if (isBlank(config.name)) {
      setStatus('error'); setMessage('Bot name must be filled'); return;
    } else { setStatus('idle'); }

    if (isBlank(config.role)) {
      setStatus('error'); setMessage('Role / persona must be filled'); return;
    } else { setStatus('idle'); }

    if (isBlank(config.company)) {
      setStatus('error'); setMessage('Company name must be filled'); return;
    } else { setStatus('idle'); }

    {
      const err = validateDescriptionQuick(config.companyDescription);
      if (err) { setStatus('error'); setMessage(err); return; } else { setStatus('idle'); }
    }

    if (isBlank(config.products)) {
      setStatus('error'); setMessage('Products / Services must be filled'); return;
    } else { setStatus('idle'); }

    if (isBlank(config.policies)) {
      setStatus('error'); setMessage('Policies / SLAs must be filled'); return;
    } else { setStatus('idle'); }

    if (!config.languages || config.languages.length === 0) {
      setStatus('error'); setMessage('Select at least one language'); return;
    } else { setStatus('idle'); }

    // require at least ONE contact method
    if (isBlank(config.contactEmail) && isBlank(config.contactPhone) && isBlank(config.contactUrl)) {
      setStatus('error'); setMessage('Provide at least one contact method (email, phone, or URL)'); return;
    } else { setStatus('idle'); }

    if (isBlank(config.supportHours)) {
      setStatus('error'); setMessage('Support hours must be filled'); return;
    } else { setStatus('idle'); }

    // personality knobs
    if (isBlank(config.personality?.voice)) {
      setStatus('error'); setMessage('Personality: Voice is required'); return;
    } else { setStatus('idle'); }

    if (isBlank(config.personality?.formality)) {
      setStatus('error'); setMessage('Personality: Formality is required'); return;
    } else { setStatus('idle'); }

    if (isBlank(config.personality?.jargon)) {
      setStatus('error'); setMessage('Personality: Jargon level is required'); return;
    } else { setStatus('idle'); }

    if (isBlank(config.personality?.sales)) {
      setStatus('error'); setMessage('Personality: Sales guidance is required'); return;
    } else { setStatus('idle'); }

    // ✅ if you reach here, everything required is present
    setStatus('idle');
    if (focus === '') {
      setFocusError(true)
      setStatus('error')
      setMessage('Focus must be filled')
      return;
    } else {
      setFocusError(false)
    }
    if (profileImage === '') {
      setStatus('error')
      setMessage('You must upload an image for your assistant!')
      return;
    } else {
      setStatus('idle')
      setMessage('')
    }
    if (selectedFilesFromDocumentUploader.length === 0) {
      setStatus('error')
      setMessage('You must upload at least one file for your assistant!')
      return;
    }
    setLoading(true)
    const payload: CreateSiteAssistantPayload = {
      config: config,
      files: selectedFilesFromDocumentUploader,
      profileImage: profileImage,
      focus: focus,
    };

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { data, error } = await createSiteAssistant(payload);
    setLoading(false)
    if (error) {
      // toast error
      setStatus('error')
      setMessage('Filed to create Assistant')
      return;
    } else {
      handleViewAssistants()
    }
    // success toast / navigate
};

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 20 }}
        transition={{ duration: 0.3 }}
      >
        <div style={{ overflowY: 'auto', height: '100vh' }}>
          <LoaderOverlay show={loading} size={18} color="#ffffff" />
          <Body>
            <Card width="92%">
                <Text
                  text="Create a Site Assistant"
                  fontSize="26px"
                  fontWeight="700"
                  lineHeight="28px"
                  color="#030303"
                  textAlign="left"
                />
                <div className='margin-top-10'></div>
                <Text
                  text="The AI Assistant will train itself on your uploaded documents and other added information."
                  fontSize="16px"
                  fontWeight="400"
                  lineHeight="28px"
                  color="#030303"
                  textAlign="left"
                />
              <Text
                  text="Add an image for your assistant, a name"
                  fontSize="16px"
                  fontWeight="400"
                  lineHeight="28px"
                  color="#030303"
                  textAlign="left"
                />
                <Text
                  text="Recruiters focus on keywords in your experience, adding them below and in {} will automatically highlight them."
                  fontSize="16px"
                  fontWeight="400"
                  lineHeight="28px"
                  color="#030303"
                  textAlign="left"
                />
                <Text
                  text="It is recommended to have a resume assistant per Resume focus e.g. one for Backend another for FullStack jobs"
                  fontSize="16px"
                  fontWeight="400"
                  lineHeight="28px"
                  color="#030303"
                  textAlign="left"
                />
                <Text
                  text="When you are finished, the Finish and Submit buttom is at the very bottom of the page."
                  fontSize="16px"
                  fontWeight="400"
                  lineHeight="28px"
                  color="#030303"
                  textAlign="left"
                />
            </Card>
            <Card width="92%">
                <Text
                  text="Focus"
                  fontSize="18px"
                  fontWeight="700"
                  lineHeight="28px"
                  color="#030303"
                  textAlign="left"
                />
                <div className="margin-top-10">
                  <Text
                  text="A focus represents the type or objective of the assistant."
                  fontSize="16px"
                  fontWeight="400"
                  lineHeight="28px"
                  color="#030303"
                  textAlign="left"
                />
                <Text
                  text="Used for your reference when viewing your assistants"
                  fontSize="16px"
                  fontWeight="400"
                  lineHeight="28px"
                  color="#030303"
                  textAlign="left"
                />
                <InputField
                    text="e.g. Customer service, Help-desk..."
                    fontSize="16px"
                    width="100%"
                    fontWeight={500}
                    error={focusError}
                    onChange={(e) => setFocus(e.target.value)}
                  />
                </div>
              </Card>
            <CardRow>
              <Card width="27%">
                <ImageUploader
                  onUploadSuccess={(imageUrl) => {
                    setProfileImage(imageUrl); // store in parent state
                  }}
                  size={227}
                  maxSizeMB={3}
                  showSpinner={true}
                />
                
              </Card>

              <Card width="63%">
                <Text
                  text="Upload Documents"
                  fontSize="18px"
                  fontWeight="700"
                  lineHeight="28px"
                  color="#030303"
                  textAlign="left"
                />
                <div className="margin-top-30">
                  <DocumentUploader
                    onFilesChange={setSelectedFilesFromDocumentUploader}
                  />
                </div>
              </Card>
            </CardRow>
            <Card width="92%">
                <Text
                  text="Instructions"
                  fontSize="18px"
                  fontWeight="700"
                  lineHeight="28px"
                  color="#030303"
                  textAlign="left"
                />
                <div className="margin-top-10">
                  <Text
                  text="Describe how you want your site assistant want to behave to users"
                  fontSize="16px"
                  fontWeight="400"
                  lineHeight="28px"
                  color="#030303"
                  textAlign="left"
                />
                <div className='margin-bottom-20'></div>
                  <SiteBotConfigForm
                    config={config}
                    onChange={merge}
                    onSubmit={handleSubmit}
                  />
                </div>
              </Card>
            
            {status !== 'idle' && (
              <Card height='90px' width="92%">
                <p
                    style={{
                    fontFamily: 'Montserrat',
                    fontSize: '14px',
                    marginTop: '20px',
                    color: status === 'success' ? '#2e7d32' : '#d32f2f',
                    textAlign: 'center',
                    }}
                >
                    {message}
                </p>
                </Card>
                )}
            <Card height='200px' width="92%">
                <div style={{ marginTop: 24, display: 'flex', justifyContent: 'flex-end' }}>
                <Button 
                onClick={handleFinish}
                width='100%'
                label='Finish & Submit'
                ></Button>
                {/* <button
                  onClick={handleFinish}
                  style={{
                    width: "100%",
                    height: "100%",
                    backgroundColor: '#8b2cd7',
                    color: '#fff',
                    border: 'none',
                    borderRadius: 8,
                    padding: '20px 26px',
                    fontSize: "16px",
                    fontFamily: 'Montserrat',
                    fontWeight: 600,
                    cursor: 'pointer',
                  }}
                >
                  Finish & Submit
                </button> */}
              </div>
              </Card>
          </Body>
        </div>
      </motion.div>

      {/* <SummarySidebar /> */}
    </>
  );
};

export default CreateSiteAssistant;
